export const ROUTE_MAIN_PATHS = {
  accountSettings: '/account',
  appConfig: '/app-config',
  challenges: '/challenges',
  groups: '/groups',
  home: '/home',
  invite: '/users/invite',
  notFound: '/404',
  tenantConfiguration: '/tenant-configuration',
  usage: '/usage',
  users: '/users',
  forgotPassword: 'forgot-password',
  login: 'login',
  resetPassword: 'reset-password',
  join: 'join',
};
